export function writeRichTextClipboard(
  html: string,
  text: string,
): Promise<'rich' | 'plain'> {
  if (copyWithExecCommand(html, text)) {
    return Promise.resolve('rich');
  }
  const clipboard: Clipboard | undefined = navigator.clipboard;
  const write =
    typeof clipboard?.write === 'function' &&
    typeof ClipboardItem !== 'undefined'
      ? clipboard.write([
          new ClipboardItem({
            'text/html': new Blob([html], { type: 'text/html' }),
            'text/plain': new Blob([text], { type: 'text/plain' }),
          }),
        ])
      : Promise.reject(new Error('clipboard-unavailable'));
  return write
    .then(() => 'rich' as const)
    .catch((error) => {
      if (clipboard?.writeText) {
        return clipboard.writeText(text).then(() => 'plain' as const);
      }
      throw error;
    });
}

function copyWithExecCommand(html: string, text: string): boolean {
  const holder = document.createElement('div');
  holder.textContent = text;
  holder.style.position = 'fixed';
  holder.style.opacity = '0';
  holder.style.pointerEvents = 'none';
  const onCopy = (event: ClipboardEvent): void => {
    event.clipboardData?.setData('text/html', html);
    event.clipboardData?.setData('text/plain', text);
    event.preventDefault();
  };
  const selection = document.getSelection();
  const ranges = selection
    ? Array.from({ length: selection.rangeCount }, (_, index) =>
        selection.getRangeAt(index),
      )
    : [];
  document.body.appendChild(holder);
  document.addEventListener('copy', onCopy, true);
  try {
    if (!selection) {
      return false;
    }
    const range = document.createRange();
    range.selectNodeContents(holder);
    selection.removeAllRanges();
    selection.addRange(range);
    return document.execCommand('copy'); // NOSONAR typescript:S1874
  } catch {
    return false;
  } finally {
    document.removeEventListener('copy', onCopy, true);
    holder.remove();
    selection?.removeAllRanges();
    ranges.forEach((range) => selection?.addRange(range));
  }
}
